export default {
    version: "356",
    buildNumber: "1a505fb",
    baseUrl: "https://cf-st.sc-cdn.net/d/hj7e4HEBwsIivY5eY5ti9?go=IgsKCTIBBEgBUFxgAQ%3D%3D&uc=92",
};
